"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jsonToPlain = jsonToPlain;
exports.jsonToQueryParams = jsonToQueryParams;
function jsonToQueryParams(obj) {
  if (!obj) {
    return '';
  }
  return "?".concat(jsonToPlain(obj));
}
function jsonToPlain(obj) {
  if (!obj) {
    return '';
  }
  return Object.keys(obj).map(function (key) {
    return "".concat(key, "=").concat(encodeURIComponent(obj[key]));
  }).join('&');
}